import { render, staticRenderFns } from "./OrderFoodTable.vue?vue&type=template&id=3486e89c"
import script from "./OrderFoodTable.vue?vue&type=script&lang=js"
export * from "./OrderFoodTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports